import { render, staticRenderFns } from "./WebsiteOrderCreate.vue?vue&type=template&id=564ecbf0&scoped=true&"
import script from "./WebsiteOrderCreate.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteOrderCreate.vue?vue&type=style&index=0&id=564ecbf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ecbf0",
  null
  
)

export default component.exports